export const timestamp = (date = false) => {
	date = date ? new Date(date).getTime() : Date.now()
	return Math.round(date / 1000)
}
